package er.prateek.crossly.share

actual fun shareText(text: String) {
    jsShareText(text)
}

actual fun startInstallReferrerCapture(onResult: (referrer: String?) -> Unit) {
    onResult(null)
}

actual fun isWebRuntime(): Boolean = true

actual fun currentPageUrl(): String = jsHref()

actual fun openExternalUrl(url: String) = jsAssign(url)

actual fun browserEnvironment(): BrowserEnvironment = BrowserEnvironment(
    userAgent = jsUserAgent(),
    language = jsLanguage(),
    documentReferrer = jsReferrer(),
    viewportWidth = jsInnerWidth(),
    viewportHeight = jsInnerHeight(),
    timezoneOffsetMinutes = jsTzOffset(),
)
